
class GrapeUIPlugin
{
	constructor(Grape, options)
	{
		this.Grape = Grape;
		this.options = options;
	}

	beforeNavbarRender()
	{
		const self = this;
		return new Promise(function(resolve, reject) {
			let account_navbar_item = self.Grape.config.navbar.find(function(item) { return (item.name == 'Account'); });
			if (window.Grape.currentSession == null)
				account_navbar_item.html = '<li>Not logged in</li>';
			else
				account_navbar_item.html = '<li><a href="#/grape-ui/my-account">Welcome ' + window.Grape.currentSession.user.username + '</a></li>';
			resolve();
		});
	}
}

export default GrapeUIPlugin;

